export const financial = {
	title: "Extracto diario",
	filename: "extracto-diario",
	details: "Ver detalles",
	noDataToShow: "No hay nada que mostrar para el período seleccionado",
	table: {
		datetime: "Fecha",
		in: "Entrada",
		out: "Salida",
		balance: "Saldo",
		withdrew: "Retirado",
		total: "Total",
	},
	summaryTitle: "Resumen para {{date}}",
	event: "Eventos",
	noResume: "No hay ningún cierre en el período",
	modality: "Modalidad",
	payvalue: "A Pagar/A Recibir",
	receive: "A recibir",
	pay: "A pagar",
};
